import type { initialBackgroundStateType } from "src/reducks/BackgroundStore/types";

export const initialBackgroundState: initialBackgroundStateType = {
  initSelectedBackground: {
    id: "",
    bought: false,
    image: "",
    name: "",
    point: 0,
  },
  selectedBackground: {
    id: "",
    bought: false,
    image: "",
    name: "",
    point: 0,
  },
};
